module.exports = __webpack_public_path__ + "static/media/wb.493b858e.mp4";